import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { white } from '@material-ui/core/colors';
import { Switch } from '@material-ui/core';

// Icons
import LockIcon from 'mdi-react/LockIcon';

const CustomSwitch = withStyles({
  switchBase: {
    color: white,
    '&$checked': {
      color: '#177EFF'
    },
    '&$checked + $bar': {
      backgroundColor: '#177EFF'
    }
  },
  checked: {},
  bar: {}
})(Switch);

const SwitchMaterial = props => {
  if (props.disabled && props.input.name === 'receipt') {
    return (
      <CustomSwitch
        {...props.input}
        checked={false}
        onChange={props.input.onChange}
        disabled={props.disabled}
        icon={<LockIcon size={12} />}
      />
    );
  } else if (props.disabled && props.input.name !== 'receipt') {
    return (
      <CustomSwitch
        {...props.input}
        checked={props.input.value}
        onChange={props.input.onChange}
        disabled={props.input.disabled || props.disabled}
        icon={<LockIcon size={12} />}
      />
    );
  } else {
    return (
      <CustomSwitch
        {...props.input}
        checked={props.input.value}
        onChange={props.input.onChange}
        disabled={props.justDisabled}
      />
    );
  }
}; // END SwitchMaterial

SwitchMaterial.propTypes = {
  disabled: PropTypes.any,
  input: PropTypes.object,
  justDisabled: PropTypes.any
};

export default SwitchMaterial;



// WEBPACK FOOTER //
// ./src/components/form/SwitchMaterial.js